/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const PlatformCam32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <rect width={32} height={32} fill={vars.bdlLightBlue} rx={6} />
            <path
                fill={vars.white}
                d="M21.163 19.639c.3-.119.634-.119.933 0l1.647.652a.394.394 0 010 .74l-7.277 2.885a1.273 1.273 0 01-.933 0l-7.276-2.884a.395.395 0 010-.74l1.652-.652c.297-.119.633-.119.931 0l4.693 1.86c.299.119.634.119.933 0zm0-3.754c.3-.118.634-.118.933 0l1.647.653a.394.394 0 010 .74l-7.277 2.884a1.273 1.273 0 01-.933 0l-7.276-2.884a.395.395 0 010-.74l1.652-.652c.297-.118.633-.118.931.001l4.693 1.86c.299.118.634.118.933 0zm-3.301-5.033c.3-.119.635-.119.933 0l4.948 1.97a.394.394 0 010 .739l-7.278 2.886a1.273 1.273 0 01-.933 0l-7.274-2.885a.395.395 0 010-.74l3.335-1.32c.298-.118.633-.118.93 0l1.383.548c.3.12.635.12.933 0zm-3.914-2.768l1.937.76c.153.06.153.252 0 .312l-1.937.76c-.285.112-.61.112-.896 0l-1.937-.76c-.153-.06-.153-.252 0-.312l1.937-.76c.285-.112.61-.112.896 0z"
            />
        </g>
    </AccessibleSVG>
);

export default PlatformCam32;
